<p-dialog header="All Activity Lists" [(visible)]="currentDisplay" [modal]="true" [style]="{width: '80vw'}" class="layer1" [blockScroll]="true" (onHide)="hideDialog()" appendTo="body">
    <div class="header p-grid p-mt-0">
        <div class="p-col-6 p-p-0">
            <input pInputText type="text" id="search" [(ngModel)]="searchText" (ngModelChange)="searchKey()" placeholder="Search by ...">
        </div>
        <div class="p-col-5 p-text-right p-p-0">
            <p-dropdown class="inlineDD timeranges" [options]="timeRanges" [(ngModel)]="selectedTimeRange" appendTo="body" optionLabel="name" (onChange)="filterActivityByDate()"></p-dropdown>
        </div>
        <div class="p-col-1 p-text-right p-p-0">
            <span class="btnBars p-mt-1 p-mr-0 p-ml-2" (click)="filterItems2.toggle($event)">
                <i class="pi pi-filter"></i>
            </span>
        </div>
    </div>
    <p-overlayPanel #filterItems2 styleClass="activityItems">
        <ng-template pTemplate>
            <ul>
                <li (click)="filterActivities(filters.ALL_ACTIVITY); filterItems2.hide($event)" [class.active]="filterType === filters.ALL_ACTIVITY">
                    <span>All Activity</span>
                </li>
                <li (click)="filterActivities(filters.USER_ACTIVITY); filterItems2.hide($event)" [class.active]="filterType === filters.USER_ACTIVITY">
                    <span>User Activity</span>
                </li>
                <li (click)="filterActivities(filters.SYSTEM_ACTIVITY); filterItems2.hide($event)" [class.active]="filterType === filters.SYSTEM_ACTIVITY">
                    <span>System Activity</span>
                </li>
                <li (click)="filterActivities(filters.LOG); filterItems2.hide($event)" [class.active]="filterType === filters.LOG">
                    <span>Log</span>
                </li>
                <li (click)="filterActivities(filters.NOTE); filterItems2.hide($event)" [class.active]="filterType === filters.NOTE">
                    <span>Note</span>
                </li>
                <li (click)="filterActivities(filters.EMAIL); filterItems2.hide($event)" [class.active]="filterType === filters.EMAIL">
                    <span>Email</span>
                </li>
                <li (click)="filterActivities(filters.FAVORITE); filterItems2.hide($event)" [class.active]="filterType === filters.FAVORITE">
                    <span>Favorite</span>
                </li>
            </ul>
        </ng-template>
    </p-overlayPanel>

    <p-card *ngFor="let s of app.allActivityLogsList; let i = index;" class="activity-card" [hidden]="s.activityName === 'ActivityFeed' && s.type === null">
        <div class="p-d-flex cursor-pointer" (click)="openActivityDetail(s)">
            <div class="activity-icon bg-email p-shadow-3" *ngIf="s.activityName === 'Email'">
                <span class="pi pi-envelope"></span>
            </div>
            <div class="activity-icon bg-log p-shadow-3 {{ s?.type ? s.type.toLowerCase() : ''}}" *ngIf="s.activityName === 'Log'">
                <span class="pi pi-file"></span>
            </div>
            <div class="activity-icon bg-note p-shadow-3" *ngIf="s.activityName === 'Note'">
                <span class="pi pi-user-edit"></span>
            </div>
            <div class="activity-icon bg-opportunity p-shadow-3" *ngIf="s.activityName === 'ActivityFeed' && s.type === 'Opportunity'">
                <span class="pi pi-money-bill"></span>
            </div>
            <div class="activity-icon bg-case p-shadow-3" *ngIf="s.activityName === 'ActivityFeed' && s.type === 'Case'">
                <span class="pi pi-ticket"></span>
            </div>
            <div class="activity-icon bg-opportunity p-shadow-3" *ngIf="s.activityName === 'ActivityFeed' && s.type === 'Account'">
                <span class="pi pi-ticket"></span>
            </div>
            <div class="activity-icon bg-case p-shadow-3" *ngIf="s.activityName === 'ActivityFeed' && s.type === 'Lead' ">
                <span class="pi pi-ticket"></span>
            </div>
            <div class="activity-icon bg-note p-shadow-3" *ngIf="s.activityName === 'ActivityFeed' && s.type === 'Contact' ">
                <span class="pi pi-ticket"></span>
            </div>
            <div class="activity-icon bg-case p-shadow-3" *ngIf="s.activityName === 'ActivityFeed' && s.type === 'ActivityLeadLog' ">
                <span class="pi pi-ticket"></span>
            </div>
            <div class="activity-icon bg-case p-shadow-3" *ngIf="s.activityName === 'ActivityFeed' && ['ActiveInactiveLeadLog',
                'ActiveInactiveAccountLog', 'ActiveInactiveOpportunityLog', 'ActiveInactiveContactLog'].includes(s.type)">
                <span class="pi pi-ticket"></span>
            </div>
            <div class="activity-icon bg-case p-shadow-3" *ngIf="s.activityName === 'ActivityFeed' && s.type === 'ActivityOpportunityLog' ">
                <span class="pi pi-ticket"></span>
            </div>
            <!-- <div class="activity-icon bg-case p-shadow-3"  *ngIf="s.activityName === 'ActivityFeed' && s.type === 'ActivityCasesLog' ">
                <span class="pi pi-ticket"></span>
            </div> -->
            <div class="activity-icon bg-case p-shadow-3" *ngIf="s.activityName === 'ActivityFeed' && s.type === 'StageChange' ">
                <span class="pi pi-ticket"></span>
            </div>
            <div class="activity-icon bg-log p-shadow-3" *ngIf="s.activityName === 'ActivityFeed' && s.type === 'AssignUser' ">
                <span class="pi pi-ticket"></span>
            </div>
            <div class="activity-icon bg-note p-shadow-3" *ngIf="s.activityName === 'ActivityFeed' && s.type === 'ResolutionDateChange' ">
                <span class="pi pi-ticket"></span>
            </div>
            <div class="activity-icon bg-log p-shadow-3" *ngIf="s.activityName === 'ActivityFeed' && s.type === 'CheckOut' ">
                <span class="pi pi-map-marker"></span>
            </div>
            <div class="activity-icon bg-log p-shadow-3" *ngIf="s.activityName === 'ActivityFeed' && s.type === 'CheckIn' ">
                <span class="pi pi-map-marker"></span>
            </div>
            <div class="activity-icon bg-event p-shadow-3" *ngIf="s.activityName === 'ActivityFeed' && s.type === 'AddressChange' ">
                <span class="pi pi-map-marker"></span>
            </div>
            <div class="activity-icon bg-opportunity p-shadow-3" *ngIf="s.activityName === 'ActivityFeed' && s.type === 'Estimate'">
                <span class="pi pi-ticket"></span>
            </div>
            <div class="activity-icon bg-opportunity p-shadow-3" *ngIf="s.activityName === 'ActivityFeed' && s.type === 'SalesOrder'">
                <span class="pi pi-ticket"></span>
            </div>
            <div class="activity-icon bg-opportunity p-shadow-3" *ngIf="s.activityName === 'ActivityFeed' && s.type === 'ActivitySalesOrderLog'">
                <span class="pi pi-ticket"></span>
            </div>
            <div class="activity-icon bg-opportunity p-shadow-3" *ngIf="s.activityName === 'ActivityFeed' && s.type === 'Invoice'">
                <span class="pi pi-ticket"></span>
            </div>
            <div class="activity-icon bg-opportunity p-shadow-3" *ngIf="s.activityName === 'ActivityFeed' && s.type === 'Invoice Received Payment'">
                <span class="pi pi-ticket"></span>
            </div>
            <div class="activity-icon bg-opportunity p-shadow-3" *ngIf="s.activityName === 'ActivityFeed' && s.type === 'CreditMemo'">
                <span class="pi pi-ticket"></span>
            </div>
            <div class="activity-icon bg-opportunity p-shadow-3" *ngIf="s.activityName === 'ActivityFeed' && s.type === 'Product'">
                <span class="pi pi-ticket"></span>
            </div>
            <div class="activity-icon bg-opportunity p-shadow-3" *ngIf="s.activityName === 'ActivityFeed' && s.type === 'PaymentReceipt'">
                <span class="pi pi-ticket"></span>
            </div>
            <div class="activity-icon bg-opportunity p-shadow-3" *ngIf="s.activityName === 'ActivityFeed' && s.type === 'ReceivedPayment'">
                <span class="pi pi-ticket"></span>
            </div>
            <div class="activity-icon bg-opportunity p-shadow-3" *ngIf="s.activityName === 'ActivityFeed' && s.type === 'PurchaseOrder'">
                <span class="pi pi-ticket"></span>
            </div>
            <div class="activity-icon bg-opportunity p-shadow-3" *ngIf="s.activityName === 'ActivityFeed' && s.type === 'ActivityPurchaseLog'">
                <span class="pi pi-ticket"></span>
            </div>
            <div class="activity-icon bg-opportunity p-shadow-3" *ngIf="s.activityName === 'ActivityFeed' && s.type === 'Vendor'">
                <span class="pi pi-ticket"></span>
            </div>
            <div class="activity-icon bg-opportunity p-shadow-3" *ngIf="s.activityName === 'ActivityFeed' && s.type === 'Location'">
                <span class="pi pi-ticket"></span>
            </div>
            <div class="activity-icon bg-opportunity p-shadow-3" *ngIf="s.activityName === 'ActivityFeed' && s.type == 'EmailReply'">
                <span class="pi pi-ticket"></span>
            </div>
            <div class="activity-icon bg-opportunity p-shadow-3" *ngIf="s.activityName === 'ActivityFeed' && s.type == ''">
                <span class="pi pi-ticket"></span>
            </div>
            <div class="activity-content">
                <ng-container *ngIf="s.activityName === 'Log'">
                    <h6 class="p-mb-1" style="display: inline-block;">
                        {{ !["Field Visit", "Email"].includes(s.type) ? s.type + ' Call' : s.type }} Note {{ s | activityBy }} {{s.createdByName}}
                    </h6>
                    <span class="p-ml-4">
                      <span>{{s.activityDate | localDate}}</span>
                    </span>
                    <span *ngIf="!isViewMode" style="float: right;color: var(--primary-color);" (click)="toggleFavourite(s.id, !s.isFavorite, s.activityName)">
                        <i class="pi pi-star" *ngIf="!s.isFavorite"></i>
                        <i class="pi pi-star-fill" *ngIf="s.isFavorite"></i>
                    </span>
                    <!-- <h6 class="p-mb-1" *ngIf="s?.type">
                        Logged
                        <span *ngIf="s?.type[0]">
                            {{ ['a', 'e', 'i', 'o', 'u'].includes(s.type[0].toLowerCase()) ? 'an' : 'a' }}
                        </span> {{ !["Field Visit", "Email"].includes(s.type) ? s.type + ' Call' : s.type }}
                    </h6> -->
                    <p style="word-break: break-all; white-space: pre-line;" class="p-mb-0">
                        {{ (s.description !== undefined || s.description !== "") && s.description?.length
                        < 343 ? s.description : s.description.substring(0,343) + "..." }} </p>
                </ng-container>
                <ng-container *ngIf="s.activityName === 'Note'">
                    <h6 class="p-mb-1" style="display: inline-block;">
                        {{s.activityName}} {{ s | activityBy }} {{s.createdByName}}
                    </h6>
                    <span class="p-ml-4">
                        <span>{{s.activityDate | localDate}}</span>
                    </span>
                    <span *ngIf="!isViewMode" style="float: right;color: var(--primary-color);" (click)="toggleFavourite(s.id, !s.isFavorite, s.activityName)">
                        <i class="pi pi-star" *ngIf="!s.isFavorite"></i>
                        <i class="pi pi-star-fill" *ngIf="s.isFavorite"></i>
                    </span>
                    <h6 class="p-mb-1">{{s.title}}</h6>
                    <p style="word-break: break-word;" class="p-mb-0">
                        {{ (s.description !== undefined || s.description !== "") && s.description?.length
                        < 343 ? s.description : s.description.substring(0,343) + "..." }} </p>
                </ng-container>

                <ng-container *ngIf="s.activityName === 'Email'">
                    <h6 class="p-mb-1" style="display: inline-block;">
                        <!-- {{s.activityName}} - {{s.createdByName}} -->
                        From -  {{s.sender ? s.sender :s.createdByName}}
                    </h6>
                    <span class="p-ml-4">
                        <span *ngIf="!s.isRead">{{s.activityDate | localDate}}</span>
                    <span *ngIf="s.isRead"><b>{{s.activityDate | localDate}}</b></span>
                    </span>
                    <span class="p-ml-2" *ngIf="s.direction === 'Received'">
                        <i class="pi pi-reply"></i>
                    </span>
                    <br>
                    <h6 class="p-mb-1 p-mt-1" style="display: inline-block;" *ngIf="s.direction === 'Sent'" tooltipPosition="top" pTooltip={{s.emailRecipients}}>
                         To - {{s.emailRecipients | splitTextByComma}}
                    </h6>
                    <h6 class="p-mb-1" style="display: inline-block;" *ngIf="s.direction === 'Received'" tooltipPosition="top" pTooltip={{s.emailRecipients}}>
                        Received E-mail From - {{s.emailRecipients | splitTextByComma}}
                    </h6>
                    <!-- <span class="p-ml-4">
                        <span>{{s.objectData.createdDate | localDate}}</span>
                    </span> -->
                    <span *ngIf="!isViewMode" style="float: right;color: var(--primary-color);" (click)="toggleFavourite(s.id, !s.isFavorite, s.activityName)">
                        <i class="pi pi-star" *ngIf="!s.isFavorite" tooltipPosition="bottom" pTooltip="set as Favorite"></i>
                        <i class="pi pi-star-fill" *ngIf="s.isFavorite" tooltipPosition="bottom" pTooltip="set as Unfavorite"></i>
                    </span>
                    <span style="float: right;color: var(--primary-color);" class="p-mr-2" tooltipPosition="bottom" pTooltip="Email is Read">
                        <i class="pi pi-check-circle" *ngIf="s.isRead"></i>
                    </span>
                    <ng-container *ngIf='s.objectData.emailAudit.emailThreads[s.objectData.emailAudit.emailThreads.length - 1].subject !==
                        "" &&
                        s.objectData.emailAudit.emailThreads[s.objectData.emailAudit.emailThreads.length - 1].subject.length
                        > 140'>
                        <div class="p-d-flex">
                            <p [innerHTML]="'Subject: ' + s.objectData.emailAudit.emailThreads[s.objectData.emailAudit.emailThreads.length -
                                1].subject.substring(0, 140)" [style.font-weight]="s.isRead && 'bold'" class="p-mb-0">
                            </p>
                            <!-- <ng-container *ngIf="s.objectData.emailAudit.emailThreads[s.objectData.emailAudit.emailThreads.length - 1].hasAttachments">
                                <i class="fa fa-paperclip pull-right">
                                    </i>
                            </ng-container> -->
                            <!-- <span style="color: var(--primary-color);" class="p-ml-3 p-mt-1">
                                <i class="fa fa-paperclip"></i>
                            </span> -->
                        </div>
                    </ng-container>
                    <ng-container *ngIf='s.objectData.emailAudit.emailThreads[s.objectData.emailAudit.emailThreads.length - 1].subject !==
                        "" &&
                        s.objectData.emailAudit.emailThreads[s.objectData.emailAudit.emailThreads.length - 1].subject.length
                        < 140'>
                        <div class="p-d-flex">
                            <p [innerHTML]="'Subject: ' + s.objectData.emailAudit.emailThreads[s.objectData.emailAudit.emailThreads.length - 1].subject" [style.font-weight]="s.isRead && 'bold'" class="p-mb-0">
                                <!-- <ng-container *ngIf="s.objectData.emailAudit.emailThreads[s.objectData.emailAudit.emailThreads.length - 1].hasAttachments">
                                    <i class="fa fa-paperclip pull-right">
                                        </i>
                                </ng-container> -->
                            </p>
                            <!-- <span style="color: var(--primary-color);" class="p-ml-3 p-mt-1">
                                <i class="fa fa-paperclip"></i>
                            </span> -->
                        </div>
                    </ng-container>
                    <p style="word-break: break-word;" class="p-mb-0" *ngIf='s.objectData.emailAudit.emailThreads[s.objectData.emailAudit.emailThreads.length - 1].bodyPreview !== "" '>
                        {{s.objectData.emailAudit.emailThreads[s.objectData.emailAudit.emailThreads.length - 1].bodyPreview.length
                        < 343 ? s.objectData.emailAudit.emailThreads[s.objectData.emailAudit.emailThreads.length - 1].bodyPreview : s.objectData.emailAudit.emailThreads[s.objectData.emailAudit.emailThreads.length
                            - 1].bodyPreview.substring(0,343) + '...'}} </p>
                </ng-container>
                <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'Case' ">
                    <h6 class="p-mb-1" style="display: inline-block;">
                        <div *ngIf="s?.isExternal">
                            <p>{{s.type}} {{ s | activityBy }} {{s?.externalUserName}}<span *ngIf="s?.externalUserName == null">{{s?.externalUserEmail}}</span> (external)</p>
                        </div>
                        <div *ngIf="!s?.isExternal">
                            {{s.type}} {{ s | activityBy }} {{s?.createdByName}}
                        </div>
                    </h6>
                    <span class="p-ml-4">
                        <span>{{s.objectData.createdDate | localDate}}</span>
                    </span>

                    <!-- <p class="p-mb-0">
                        <span *ngIf="s?.ticket?.category?.name"> Category: {{s?.ticket?.category?.name}}</span>
                        <span *ngIf="s?.ticket?.subCategory?.name">, SubCategory: {{s?.ticket?.subCategory?.name}}</span>

                    </p>
                    <p style="word-break: break-all;" class="p-mb-0">
                        {{ (s.ticket.TicketDesc !== undefined || s.ticket.TicketDesc !== "")
                        && s.ticket.TicketDesc?.length < 343 ? s.ticket.TicketDesc :
                        s.ticket.TicketDesc.substring(0,343) + "..." }}
                    </p> -->
                    <p class="p-mb-0" [innerHTML]=s?.description>

                    </p>
                </ng-container>
                <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'Account' && s.objectData?.action!='Convert'">
                    <h6 class="p-mb-1" style="display: inline-block;">
                        {{s.type}} {{ s | activityBy }} {{s.createdByName}}
                    </h6>
                    <span class="p-ml-4">
                        <span>{{s.objectData.createdDate | localDate}}</span>
                    </span>
                    <p style="word-break: break-all;" class="p-mb-0">
                        {{ (s.objectData.comment !== undefined || s.objectData.comment !== "") && s.objectData.comment?.length
                        < 343 ? s.objectData.comment : s.objectData.comment?.substring(0,343) + "..." }} </p>
                </ng-container>
                <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'Account'  && s.objectData?.action=='Convert'">
                    <h6 class="p-mb-1" style="display: inline-block;">
                        Lead Converted to Account by {{s.createdByName}}
                    </h6>
                    <span class="p-ml-4">
                        <span>{{s.objectData.createdDate | localDate}}</span>
                    </span>
                    <p style="word-break: break-all;" class="p-mb-0">
                        {{ (s.objectData.comment !== undefined || s.objectData.comment !== "") && (s.objectData.comment?.split(':')?.length) > 1 ? (s.objectData.comment?.split(':')[0] + ": ") : s.objectData.comment?.substring(0,343) + "..." }}
                        <a style="color: var(--primary-color);" *ngIf="(s.objectData.comment !== undefined || s.objectData.comment !== '') && (s.objectData.comment.split(':').length) > 1" (click)="convertPageNavigation(s)"> {{ s.objectData.comment?.split(':')[1] }}</a>
                    </p>
                </ng-container>
                <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'Contact' ">
                    <h6 class="p-mb-1" style="display: inline-block;">
                        <div *ngIf="s?.isExternal">
                            <p>{{s.type}} {{ s | activityBy }} {{s?.externalUserName}}<span *ngIf="s?.externalUserName == null">{{s?.externalUserEmail}}</span> (external)</p>
                        </div>
                        <div *ngIf="!s?.isExternal">
                            {{s.type}} {{ s | activityBy }} {{s?.createdByName}}
                        </div>
                    </h6>
                    <span class="p-ml-4">
                        <span>{{s.objectData.createdDate | localDate}}</span>
                    </span>
                    <p style="word-break: break-all;" class="p-mb-0">
                        {{ (s.objectData.comment !== undefined || s.objectData.comment !== "") && s.objectData.comment?.length
                        < 343 ? s.objectData.comment : s.objectData.comment?.substring(0,343) + "..." }} </p>
                </ng-container>
                <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'Lead' ">
                    <h6 class="p-mb-1" style="display: inline-block;">
                        <div *ngIf="s?.isExternal">
                            <p>{{s.type}} {{ s | activityBy }} {{s?.externalUserName}}<span *ngIf="s?.externalUserName == null">{{s?.externalUserEmail}}</span> (external)</p>
                        </div>
                        <div *ngIf="!s?.isExternal">
                            {{s.type}} {{ s | activityBy }} {{s?.createdByName}}
                        </div>
                    </h6>
                    <span class="p-ml-4">
                        <span>{{s.objectData.createdDate | localDate}}</span>
                    </span>
                    <p style="word-break: break-all;" class="p-mb-0">
                        {{ (s.objectData.comment !== undefined || s.objectData.comment !== "") && s.objectData.comment?.length
                        < 343 ? s.objectData.comment : s.objectData.comment?.substring(0,343) + "..." }} </p>
                </ng-container>

                <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'ActivityLeadLog' ">
                    <h6 class="p-mb-1" style="display: inline-block;">
                        Lead {{ s | activityBy }} {{s.createdByName}} to {{s.objectData?.stage?.name}}
                    </h6>
                    <span class="p-ml-4">
                        <span>{{s.objectData.createdDate | localDate}}</span>
                    </span>
                    <p style="word-break: break-all;" class="p-mb-0">
                        {{ (s.objectData.comment !== undefined || s.objectData.comment !== "") && s.objectData.comment?.length
                        < 343 ? s.objectData.comment : s.objectData.comment?.substring(0,343) + "..." }} </p>
                </ng-container>

                <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'ActiveInactiveAccountLog' ">
                    <h6 class="p-mb-1" style="display: inline-block;">
                        Account {{s?.objectData?.status?.name}} by {{s.createdByName}}
                    </h6>
                    <span class="p-ml-4">
                        <span>{{s.objectData.createdDate | localDate}}</span>
                    </span>
                    <p style="word-break: break-all;" class="p-mb-0">
                        {{ (s.objectData.comment !== undefined || s.objectData.comment !== "") && s.objectData.comment?.length
                        < 343 ? s.objectData.comment : s.objectData.comment?.substring(0,343) + "..." }} </p>
                </ng-container>

                <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'ActiveInactiveLeadLog' ">
                    <h6 class="p-mb-1" style="display: inline-block;">
                        Lead {{s?.objectData?.status?.name}} by {{s.createdByName}}
                    </h6>
                    <span class="p-ml-4">
                        <span>{{s.objectData.createdDate | localDate}}</span>
                    </span>
                    <p style="word-break: break-all;" class="p-mb-0">
                        {{ (s.objectData.comment !== undefined || s.objectData.comment !== "") && s.objectData.comment?.length
                        < 343 ? s.objectData.comment : s.objectData.comment?.substring(0,343) + "..." }} </p>
                </ng-container>

                <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'ActiveInactiveContactLog' ">
                    <h6 class="p-mb-1" style="display: inline-block;">
                        Contact {{s?.objectData?.status?.name}} by {{s.createdByName}}
                    </h6>
                    <span class="p-ml-4">
                        <span>{{s.objectData.createdDate | localDate}}</span>
                    </span>
                    <p style="word-break: break-all;" class="p-mb-0">
                        {{ (s.objectData.comment !== undefined || s.objectData.comment !== "") && s.objectData.comment?.length
                        < 343 ? s.objectData.comment : s.objectData.comment?.substring(0,343) + "..." }} </p>
                </ng-container>

                <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'ActiveInactiveOpportunityLog' ">
                    <h6 class="p-mb-1" style="display: inline-block;">
                        Opportunity {{s?.objectData?.status?.name}} by {{s.createdByName}}
                    </h6>
                    <span class="p-ml-4">
                        <span>{{s.objectData.createdDate | localDate}}</span>
                    </span>
                    <p style="word-break: break-all;" class="p-mb-0">
                        {{ (s.objectData.comment !== undefined || s.objectData.comment !== "") && s.objectData.comment?.length
                        < 343 ? s.objectData.comment : s.objectData.comment?.substring(0,343) + "..." }} </p>
                </ng-container>

                <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type == 'EmailReply' ">
                    <h6 class="p-mb-1" style="display: inline-block;">
                        <div *ngIf="s?.isExternal">
                            <p>{{s?.externalUserName}}<span *ngIf="s?.externalUserName == null">{{s?.externalUserEmail}}</span> (external)</p>
                        </div>
                        <div *ngIf="!s?.isExternal">
                            {{s?.createdByName}}
                        </div>
                    </h6>
                    <span class="p-ml-4">
                        <span>{{s.objectData.createdDate | localDate}}</span>
                    </span>
                    <p style="word-break: break-all; white-space: pre-line;" class="p-mb-0">
                        {{ (s.objectData?.comment !== undefined || s.objectData?.comment !== "") && s.objectData?.comment.length
                        < 343 ? s.objectData?.comment : s.objectData?.comment.substring(0,343) + "..." }} </p>
                </ng-container>

                <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'CheckIn' ">
                    <h6 class="p-mb-1" style="display: inline-block;">
                        Visited by {{s.createdByName}}
                    </h6>
                    <span class="p-ml-4">
                        <span>{{s.objectData.createdDate | localDate}}</span>
                    </span>
                    <p *ngIf="s.description == 'Check In - Check Out' ">
                        Check In {{s.checkInDateTime | localDate: 'h:mm a'}} - Check Out {{s.checkOutDateTime | localDate: 'h:mm a'}}
                    </p>
                    <p *ngIf="s.description == 'Check In'">
                        Check In {{s.objectData.createdDate | localDate: 'h:mm a'}}
                    </p>
                </ng-container>
                <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'CheckOut' ">
                    <h6 class="p-mb-1" style="display: inline-block;">
                        Visited by {{s.createdByName}}
                    </h6>
                    <span class="p-ml-4">
                        <span>{{s.objectData.createdDate | localDate}}</span>
                    </span>
                    <p style="word-break: break-all;" class="p-mb-0">
                        Check Out {{s.objectData.createdDate | localDate: 'h:mm a'}}
                    </p>
                </ng-container>
                <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'AddressChange' ">
                    <h6 class="p-mb-1" style="display: inline-block;">
                        Location Updated by {{s.createdByName}}
                    </h6>
                    <span class="p-ml-4">
                        <span>{{s.objectData.createdDate | localDate}}</span>
                    </span>
                    <p style="word-break: break-all;" class="p-mb-0">{{ s?.objectData?.refObjectId==2?'Account':'Lead' }} location updated while check in.</p>
                </ng-container>
                <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'ActivityOpportunityLog' ">
                    <h6 class="p-mb-1" style="display: inline-block;">
                        Opportunity {{ s | activityBy }} {{s.createdByName}} to {{s.objectData.stage.name}}
                    </h6>
                    <span class="p-ml-4">
                        <span>{{s.objectData.createdDate | localDate}}</span>
                    </span>
                    <p style="word-break: break-all;" class="p-mb-0">
                        {{ (s.objectData.comment !== undefined || s.objectData.comment !== "") && s.objectData.comment?.length
                        < 343 ? s.objectData.comment : s.objectData.comment?.substring(0,343) + "..." }} </p>
                </ng-container>
                <!-- <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'ActivityCasesLog' ">
                <h6 class="p-mb-1" style="display: inline-block;">
                    Case - {{s.createdByName}} - {{s.objectData.stage?.name}}
                </h6>
                <span class="p-ml-4">
                    <span>{{s.objectData.createdDate | localDate}}</span>
                </span>
                <p style="word-break: break-all;" class="p-mb-0" [innerHTML] = s?.description>

                </p>
            </ng-container> -->
                <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'AssignUser' ">
                    <h6 class="p-mb-1" style="display: inline-block;">
                        Case {{ s | activityBy }} {{s.createdByName}}
                    </h6>
                    <span class="p-ml-4">
                        <span>{{s.objectData.createdDate | localDate:'MM/DD/YYYY | h:mm a'}}</span>
                    </span>
                    <p style="word-break: break-all;" class="p-mb-0" [innerHTML]=s?.description></p>
                </ng-container>
                <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'ResolutionDateChange' ">
                    <h6 class="p-mb-1" style="display: inline-block;">
                        Case {{ s | activityBy }} {{s.createdByName}}
                    </h6>
                    <span class="p-ml-4">
                        <span>{{s.objectData.createdDate | localDate:'MM/DD/YYYY | h:mm a'}}</span>
                    </span>
                    <p style="word-break: break-all;" class="p-mb-0" [innerHTML]=s?.description></p>
                </ng-container>
                <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'StageChange' ">
                    <h6 class="p-mb-1" style="display: inline-block;">
                        {{s?.description}} {{ s | activityBy }} {{s.createdByName}}
                    </h6>
                    <span class="p-ml-4">
                        <span>{{s.objectData.createdDate | localDate:'MM/DD/YYYY | h:mm a'}}</span>
                    </span>
                    <p style="word-break: break-all; white-space: pre-line;" class="p-mb-0">
                        {{ (s?.objectData?.comment !== undefined || s?.objectData?.comment !== "") && s?.objectData?.comment?.length
                        < 343 ? s?.objectData?.comment : s?.objectData?.comment.substring(0,343) + "..." }} </p>
                </ng-container>
                <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'Opportunity' ">
                    <h6 class="p-mb-1" style="display: inline-block;">
                        {{s.type}} - {{s.opportunity.opportunityNo}} {{ s | activityBy }} {{s.createdByName}}
                    </h6>
                    <span class="p-ml-4">
                        <span>{{s.objectData.createdDate | localDate:'MM/DD/YYYY | h:mm a'}}</span>
                    </span>

                    <p class="p-mb-0">
                        <span *ngIf="s.opportunity.totalAmount"> Amt: {{s.opportunity?.totalAmount | number:'1.2-2' | currencySymbol}},</span>
                        <span *ngIf="s.opportunity.expectedDate"> Close date: {{s.opportunity?.expectedDate | date:'MM/dd/yyyy'}}
                        </span>
                    </p>
                    <p style="word-break: break-all;" class="p-mb-0">
                        {{ (s.opportunity.description !== undefined || s.opportunity.description !== "") && s.opportunity.description?.length
                        < 343 ? s.opportunity.description : s.opportunity.description?.substring(0,343) + "..." }} </p>
                </ng-container>
                <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'Estimate' ">
                    <h6 class="p-mb-1" style="display: inline-block;">
                        {{s.type}} - {{s.estimate?.number}} {{ s | activityBy }} {{s.createdByName}}
                    </h6>
                    <span class="p-ml-4">
                        <span>{{s.objectData?.createdDate | localDate}}</span>
                    </span>
                    <p class="p-mb-0" *ngIf="s.estimate"> {{s.type}} - {{s.estimate?.netAmount | number: "1.2-2"}} , {{s.estimate?.estimateStatus}} - {{s.objectData?.createdDate | localDate}}</p>
                    <!-- Estimates create from workflow -->
                    <p style="word-break: break-all;" class="p-mb-0" *ngIf="s.estimate && s.activitySource == 'WF' && s.objectData?.action != 'Update' && s.objectData?.action != 'ApprovalFromWF'">
                        Estimate {{s.estimate?.number}} created from Workflow {{s.sourceName}}
                        <!-- <a [routerLink]="['/workflow']" [queryParams]="{id: s.sourceId, data: s.sourceName}">{{s.sourceName}}</a> -->
                    </p>
                    <!-- Estimates update from workflow -->
                    <p style="word-break: break-all;" class="p-mb-0" *ngIf="s.estimate && s.activitySource == 'WF' && s.objectData?.action == 'Update'">
                        Estimate {{s.estimate?.number}} updated from Workflow {{s.sourceName}}
                        <!-- <a [routerLink]="['/workflow']" [queryParams]="{id: s.sourceId, data: s.sourceName}">{{s.sourceName}}</a> -->
                    </p>
                    <!-- Estimates to SalesOrder Comment -->
                    <p style="word-break: break-all;" class="p-mb-0" *ngIf="s.estimate && s.estimate?.salesOrderId != 0 && s.objectData?.action != 'Approve/Decline' && s.objectData?.action != 'ApprovalFromWF'">
                        Estimate {{s.estimate?.number}} converted to Sales Order
                        <a [routerLink]="['/sales-order']" [queryParams]="{id: s.estimate?.salesOrderId, module: soChannel.SALES_ORDER, data: s.estimate?.salesOrderNo, globalSearch: 'true', channelId: '3', statusId: '1'}">{{s.estimate?.salesOrderNo}}</a>
                    </p>
                    <!-- Estimates to Invoice Comment -->
                    <p style="word-break: break-all;" class="p-mb-0" *ngIf="s.estimate && s.estimate?.invoiceId != 0 && s.objectData?.action != 'Approve/Decline' && s.objectData?.action != 'ApprovalFromWF'">
                        Estimate {{s.estimate?.number}} converted to Invoice
                        <a [routerLink]="['/invoicing']" [queryParams]="{id: s.estimate?.invoiceId, module: 'Invoice', data: s.estimate?.invoiceNo, globalSearch: 'true', channelId: '4', statusId: '1'}">{{s.estimate?.invoiceNo}}</a>
                    </p>
                    <!-- Estimates Comment -->
                    <p style="word-break: break-all;" class="p-mb-0" *ngIf="s.estimate && s.estimate?.salesOrderId == 0 && s.estimate?.invoiceId == 0 && s.activitySource != 'WF' && s.objectData?.action != 'Approve/Decline'">
                        {{ (s.objectData?.comment !== undefined || s.objectData?.comment !== "") && s.objectData?.comment?.length
                        < 343 ? s.objectData?.comment : s.objectData?.comment?.substring(0,343) + "..." }}
                    </p>
                    <p style="word-break: break-all;" class="p-mb-0" *ngIf="s.activitySource == 'WF' && s.objectData?.action == 'Update' && s.objectData?.comment !== undefined && s.objectData?.comment !== '' && s?.objectData?.comment?.toLowerCase().includes('approved by')">
                        {{s.objectData?.comment}} {{s.createdByName}}
                    </p>
                    <!-- Estimate Approved/Declined by Approval Process -->
                    <p style="word-break: break-all;" class="p-mb-0" *ngIf="s.activitySource != 'WF' && s.objectData?.action == 'Approve/Decline' && s.objectData?.comment !== undefined && s.objectData?.comment !== ''">
                        {{s.objectData?.comment}} {{s.createdByName}}
                    </p>
                    <!-- Estimate Pending For Approval -->
                    <p style="word-break: break-all;" class="p-mb-0" *ngIf="s.estimate && s.activitySource == 'WF' && s.objectData?.action == 'ApprovalFromWF'">
                        {{s.objectData?.comment}} through Workflow {{s.sourceName}}
                    </p>
                </ng-container>
                <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'SalesOrder' ">
                    <h6 class="p-mb-1" style="display: inline-block;">
                        {{s.type}} - {{s.salesOrder?.number}} {{ s | activityBy }} {{s.createdByName}}
                    </h6>
                    <span class="p-ml-4">
                        <span>{{s.objectData?.createdDate | localDate}}</span>
                    </span>
                    <p class="p-mb-0" *ngIf="s.salesOrder"> {{s.type}} - {{s.salesOrder?.netAmount | number: "1.2-2"}} , {{s.salesOrder?.salesOrderStage}} - {{s.objectData?.createdDate | localDate}}</p>
                    <!-- Sales Order Create from Workflow -->
                    <p style="word-break: break-all;" class="p-mb-0" *ngIf="s.salesOrder && s.activitySource == 'WF' && s.objectData?.action != 'Update' && s.objectData?.action != 'ApprovalFromWF'">
                        Sales Order {{s.salesOrder?.number}} is created from Workflow {{s.sourceName}}
                        <!-- <a [routerLink]="['/workflow']" [queryParams]="{id: s.sourceId, data: s.sourceName}">{{s.sourceName}}</a> -->
                    </p>
                    <!-- Sales Order Update from Workflow -->
                    <p style="word-break: break-all;" class="p-mb-0" *ngIf="s.salesOrder && s.activitySource == 'WF' && s.objectData?.action == 'Update'">
                        Sales Order {{s.salesOrder?.number}} is updated from Workflow {{s.sourceName}}
                        <!-- <a [routerLink]="['/workflow']" [queryParams]="{id: s.sourceId, data: s.sourceName}">{{s.sourceName}}</a> -->
                    </p>
                    <!-- Sales Order from Estimates -->
                    <p style="word-break: break-all;" class="p-mb-0" *ngIf="s.salesOrder && s.salesOrder?.estimateId != 0 && s.objectData?.action != 'Update' && s.objectData?.action != 'Approve/Decline' && s.objectData?.action != 'ApprovalFromWF'">
                        Sales Order {{s.salesOrder?.number}} is created from Estimate
                        <a [routerLink]="['/estimates']" [queryParams]="{id: s.salesOrder?.estimateId, module: 'Estimate', data: s.salesOrder?.estimateNo, globalSearch: 'true', channelId: '2', statusId: '1'}">{{s.salesOrder?.estimateNo}}</a>
                    </p>
                    <!-- Sales Order to Invoice -->
                    <p style="word-break: break-all;" class="p-mb-0" *ngIf="s.objectData && s.objectData?.action == 'Update' && s.objectData?.comment?.includes('Converted to Invoice')">
                        Sales Order {{s.salesOrder?.number}} is converted to Invoice
                        <a [routerLink]="['/invoicing']" [queryParams]="{id: s.salesOrder?.invoiceId, module: 'Invoice', data: s.salesOrder?.invoiceNo, globalSearch: 'true', channelId: '4', statusId: '1'}">{{s.salesOrder?.invoiceNo}}</a>
                    </p>
                    <!-- Sales Order update log -->
                    <p style="word-break: break-all;" class="p-mb-0" *ngIf="s.objectData && s.objectData?.action == 'Update' && !s.objectData?.comment?.includes('Converted to Invoice') && s.activitySource != 'WF'">
                        {{ (s.objectData?.comment !== undefined || s.objectData?.comment !== "") && s.objectData?.comment?.length
                        < 343 ? s.objectData?.comment : s.objectData?.comment?.substring(0,343) + "..." }}
                    </p>
                    <!-- Sales Order create log -->
                    <p style="word-break: break-all;" class="p-mb-0" *ngIf="s.objectData?.action != 'Update' && s.objectData?.action != 'Approve/Decline' && s.salesOrder && s.salesOrder?.estimateId == 0 && s.activitySource != 'WF'">
                        {{ (s.objectData?.comment !== undefined || s.objectData?.comment !== "") && s.objectData?.comment?.length
                        < 343 ? s.objectData?.comment : s.objectData?.comment?.substring(0,343) + "..." }}
                    </p>
                    <p style="word-break: break-all;" class="p-mb-0" *ngIf="s.activitySource == 'WF' && s.objectData?.action == 'Update' && s.objectData?.comment !== undefined && s.objectData?.comment !== '' && s?.objectData?.comment?.toLowerCase().includes('approved by')">
                        {{s.objectData?.comment}} {{s.createdByName}}
                    </p>
                    <!-- SalesOrder Approved/Declined by Approval Process -->
                    <p style="word-break: break-all;" class="p-mb-0" *ngIf="s.activitySource != 'WF' && s.objectData?.action == 'Approve/Decline' && s.objectData?.comment !== undefined && s.objectData?.comment !== ''">
                        {{s.objectData?.comment}} {{s.createdByName}}
                    </p>
                    <!-- SalesOrder Pending For Approval -->
                    <p style="word-break: break-all;" class="p-mb-0" *ngIf="s.salesOrder && s.activitySource == 'WF' && s.objectData?.action == 'ApprovalFromWF'">
                        {{s.objectData?.comment}} through Workflow {{s.sourceName}}
                    </p>
                </ng-container>
                <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'ActivitySalesOrderLog' ">
                    <h6 class="p-mb-1" style="display: inline-block;">
                        Sales Order {{ s | activityBy }} {{s.createdByName}}
                    </h6>
                    <span class="p-ml-4">
                        <span>{{s.objectData.createdDate | localDate}}</span>
                    </span>
                    <p style="word-break: break-all;" class="p-mb-0" [innerHTML]="s.objectData?.comment">
                        <!-- {{ (s.objectData?.comment !== undefined || s.objectData?.comment !== "")
                        && s.objectData?.comment.length < 343 ? s.objectData?.comment :
                        s.objectData?.comment.substring(0,343) + "..." }} -->
                    </p>
                </ng-container>
                <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'Invoice' ">
                    <h6 class="p-mb-1" style="display: inline-block;">
                        {{s.type}} - {{s.invoice?.number}} {{ s | activityBy }} {{s.createdByName}}
                    </h6>
                    <span class="p-ml-4">
                        <span>{{s.objectData?.createdDate | localDate}}</span>
                    </span>
                    <p class="p-mb-0" *ngIf="s.invoice"> {{s.type}} - {{s.invoice?.netAmount | number: "1.2-2"}} , {{s.invoice?.invoiceStatus}} - {{s.objectData?.createdDate | localDate}}</p>
                    <!-- Invoice create from Workflow -->
                    <p style="word-break: break-all;" class="p-mb-0" *ngIf="s.invoice && s.activitySource == 'WF' && s.objectData?.action != 'Update' && s.objectData?.action != 'ApprovalFromWF'">
                        Invoice {{s.invoice?.number}} is created from Workflow {{s.sourceName}}
                        <!-- <a [routerLink]="['/workflow']" [queryParams]="{id: s.sourceId, data: s.sourceName}">{{s.sourceName}}</a> -->
                    </p>
                    <!-- Invoice update from Workflow -->
                    <p style="word-break: break-all;" class="p-mb-0" *ngIf="s.invoice && s.activitySource == 'WF' && s.objectData?.action == 'Update'">
                        Invoice {{s.invoice?.number}} is updated from Workflow {{s.sourceName}}
                        <!-- <a [routerLink]="['/workflow']" [queryParams]="{id: s.sourceId, data: s.sourceName}">{{s.sourceName}}</a> -->
                    </p>
                    <!-- Invoice from Estimates -->
                    <p style="word-break: break-all;" class="p-mb-0" *ngIf="s.invoice && s.invoice?.estimateId != 0 && s.objectData?.action != 'Update' && s.objectData?.action != 'Approve/Decline' && s.objectData?.action != 'ApprovalFromWF'">
                        Invoice {{s.invoice?.number}} is created from Estimate
                        <a [routerLink]="['/estimates']" [queryParams]="{id: s.invoice?.estimateId, module: 'Estimate', data: s.invoice?.estimateNo, globalSearch: 'true', channelId: '2', statusId: '1'}">{{s.invoice?.estimateNo}}</a>
                    </p>
                    <!-- Invoice from Sales Order -->
                    <p style="word-break: break-all;" class="p-mb-0" *ngIf="s.invoice && s.invoice?.salesOrderId != 0 && s.objectData?.action != 'Update' && s.objectData?.action != 'Approve/Decline' && s.objectData?.action != 'ApprovalFromWF'">
                        Invoice {{s.invoice?.number}} is created from Sales Order
                        <a [routerLink]="['/sales-order']" [queryParams]="{id: s.invoice?.salesOrderId, module: 'SalesOrder', data: s.invoice?.salesOrderNo, globalSearch: 'true', channelId: '3', statusId: '1'}">{{s.invoice?.salesOrderNo}}</a>
                    </p>
                    <!-- Invoice update log -->
                    <p style="word-break: break-all;" class="p-mb-0" *ngIf="s.objectData?.action == 'Update' && s.activitySource != 'WF'">
                        {{ (s.objectData?.comment !== undefined || s.objectData?.comment !== "") && s.objectData?.comment.length
                        < 343 ? s.objectData?.comment : s.objectData?.comment.substring(0,343) + "..." }}
                    </p>
                    <!-- Invoice create log -->
                    <p style="word-break: break-all;" class="p-mb-0" *ngIf="s.objectData?.action != 'Update' && s.objectData?.action != 'Approve/Decline' && s.invoice && s.invoice?.estimateId == 0 && s.invoice?.salesOrderId == 0 && s.activitySource != 'WF'">
                        {{ (s.objectData?.comment !== undefined || s.objectData?.comment !== "") && s.objectData?.comment.length
                        < 343 ? s.objectData?.comment : s.objectData?.comment.substring(0,343) + "..." }}
                    </p>
                    <p style="word-break: break-all;" class="p-mb-0" *ngIf="s.activitySource == 'WF' && s.objectData?.action == 'Update' && s.objectData?.comment !== undefined && s.objectData?.comment !== '' && s?.objectData?.comment?.toLowerCase().includes('approved by')">
                        {{s.objectData?.comment}} {{s.createdByName}}
                    </p>
                    <!-- Invoice Approved/Declined by Approval Process -->
                    <p style="word-break: break-all;" class="p-mb-0" *ngIf="s.activitySource != 'WF' && s.objectData?.action == 'Approve/Decline' && s.objectData?.comment !== undefined && s.objectData?.comment !== ''">
                        {{s.objectData?.comment}} {{s.createdByName}}
                    </p>
                    <!-- Invoice Pending For Approval -->
                    <p style="word-break: break-all;" class="p-mb-0" *ngIf="s.invoice && s.activitySource == 'WF' && s.objectData?.action == 'ApprovalFromWF'">
                        {{s.objectData?.comment}} through Workflow {{s.sourceName}}
                    </p>
                </ng-container>
                <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'Invoice Received Payment' ">
                    <h6 class="p-mb-1" style="display: inline-block;">
                        Invoice - {{s.invoice?.number}} {{ s | activityBy }} {{s.createdByName}}
                    </h6>
                    <span class="p-ml-4">
                        <span>{{s.objectData?.createdDate | localDate}}</span>
                    </span>
                    <p class="p-mb-0"> Invoice - {{s.invoice?.netAmount | number: "1.2-2"}} , {{s.invoice?.invoiceStatus}} - {{s.objectData?.createdDate | localDate}}</p>
                    <p style="word-break: break-all;" class="p-mb-0">
                        {{ (s.objectData?.comment !== undefined || s.objectData?.comment !== "") && s.objectData?.comment.length
                        < 343 ? s.objectData?.comment : s.objectData?.comment.substring(0,343) + "..." }} </p>
                </ng-container>
                <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'CustomerRMA' ">
                    <h6 class="p-mb-1" style="display: inline-block;">
                        {{s.type}} - {{s.customerRMA?.number}} {{ s | activityBy }} {{s.createdByName}}
                    </h6>
                    <span class="p-ml-4">
                        <span>{{s.objectData?.createdDate | localDate}}</span>
                    </span>
                    <p class="p-mb-0"> {{s.type}} - {{s.customerRMA?.netAmount | number: "1.2-2"}} , {{s.customerRMA?.rmaStatus}} - {{s.objectData?.createdDate | localDate}}</p>
                    <!-- Customer RMA update log -->
                    <p style="word-break: break-all;" class="p-mb-0" *ngIf="s.objectData?.action == 'Update'">
                        {{ (s.objectData?.comment !== undefined || s.objectData?.comment !== "") && s.objectData?.comment.length
                        < 343 ? s.objectData?.comment : s.objectData?.comment.substring(0,343) + "..." }} </p>
                            <!-- Customer RMA create log -->
                            <p style="word-break: break-all;" class="p-mb-0" *ngIf="s.objectData?.action != 'Update' && s.customerRMA && s.customerRMA?.estimateId == 0 && s.customerRMA?.salesOrderId == 0">
                                {{ (s.objectData?.comment !== undefined || s.objectData?.comment !== "") && s.objectData?.comment.length
                                < 343 ? s.objectData?.comment : s.objectData?.comment.substring(0,343) + "..." }} </p>
                </ng-container>
                <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'CreditMemo' ">
                    <h6 class="p-mb-1" style="display: inline-block;">
                        {{s.type}} - {{s.creditMemo?.number}} {{ s | activityBy }} {{s.createdByName}}
                    </h6>
                    <span class="p-ml-4">
                        <span>{{s.objectData?.createdDate | localDate}}</span>
                    </span>
                    <p class="p-mb-0"> {{s.type}} - {{s.creditMemo?.netAmount | number: "1.2-2"}} , {{s.creditMemo?.creditMemoStatus}} - {{s.objectData?.createdDate | localDate}}</p>

                    <!-- Credit Memo is created from Workflow -->
                    <p style="word-break: break-all;" class="p-mb-0" *ngIf="s.creditMemo && s.activitySource == 'WF' && s.objectData?.action == 'Insert'">
                        Credit memo {{s.creditMemo?.number}} is created from Workflow {{s.sourceName}}
                        <!-- <a [routerLink]="['/workflow']" [queryParams]="{id: s.sourceId, data: s.sourceName}">{{s.sourceName}}</a> -->
                    </p>
                    <p style="word-break: break-all;" class="p-mb-0" *ngIf="s.activitySource != 'WF'">
                        {{ (s.objectData?.comment !== undefined || s.objectData?.comment !== "") && s.objectData?.comment.length
                        < 343 ? s.objectData?.comment : s.objectData?.comment.substring(0,343) + "..." }}
                    </p>
                </ng-container>
                <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'Product' ">
                    <h6 class="p-mb-1" style="display: inline-block;">
                        {{s.type}} {{ s | activityBy }} {{s.createdByName}}
                    </h6>
                    <span class="p-ml-4">
                        <span>{{s.objectData.createdDate | localDate}}</span>
                    </span>
                    <p style="word-break: break-all;" class="p-mb-0">
                        {{ (s.objectData?.comment !== undefined || s.objectData?.comment !== "") && s.objectData?.comment.length
                        < 343 ? s.objectData?.comment : s.objectData?.comment.substring(0,343) + "..." }} </p>
                </ng-container>
                <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'PurchaseOrder' ">
                    <h6 class="p-mb-1" style="display: inline-block;">
                        {{s.type}} {{ s | activityBy }} {{s.createdByName}}
                    </h6>
                    <span class="p-ml-4">
                        <span>{{s.objectData.createdDate | localDate}}</span>
                    </span>
                    <p style="word-break: break-all;" class="p-mb-0">
                        {{ (s.objectData?.comment !== undefined || s.objectData?.comment !== "") && s.objectData?.comment.length
                        < 343 ? s.objectData?.comment : s.objectData?.comment.substring(0,343) + "..." }} </p>
                </ng-container>
                <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'ActivityPurchaseLog' ">
                    <h6 class="p-mb-1" style="display: inline-block;">
                        Purchase {{ s | activityBy }} {{s.createdByName}} to {{s.objectData?.stage?.name}}
                    </h6>
                    <span class="p-ml-4">
                        <span>{{s.objectData.createdDate | localDate}}</span>
                    </span>
                    <p style="word-break: break-all;" class="p-mb-0" [innerHTML]="s.objectData?.comment">
                        <!-- {{ (s.objectData?.comment !== undefined || s.objectData?.comment !== "")
                        && s.objectData?.comment.length < 343 ? s.objectData?.comment :
                        s.objectData?.comment.substring(0,343) + "..." }} -->
                    </p>
                </ng-container>
                <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'Vendor' ">
                    <h6 class="p-mb-1" style="display: inline-block;">
                        {{s.type}} {{ s | activityBy }} {{s.createdByName}}
                    </h6>
                    <span class="p-ml-4">
                        <span>{{s.objectData.createdDate | localDate}}</span>
                    </span>
                    <p style="word-break: break-all;" class="p-mb-0">
                        {{ (s.objectData?.comment !== undefined || s.objectData?.comment !== "") && s.objectData?.comment.length
                        < 343 ? s.objectData?.comment : s.objectData?.comment.substring(0,343) + "..." }} </p>
                </ng-container>
                <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'PaymentReceipt' ">
                    <h6 class="p-mb-1" style="display: inline-block;">
                        {{s.type}} - {{s.createdByName}}
                    </h6>
                    <span class="p-ml-4">
                        <span>{{s.objectData.createdDate | localDate}}</span>
                    </span>
                    <p style="word-break: break-all;" class="p-mb-0">
                        {{ (s.objectData?.comment !== undefined || s.objectData?.comment !== "") && s.objectData?.comment.length
                        < 343 ? s.objectData?.comment : s.objectData?.comment.substring(0,343) + "..." }} </p>
                </ng-container>
                <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'ReceivedPayment' ">
                    <h6 class="p-mb-1" style="display: inline-block;">
                        {{s.type}} - {{s.receivedPayment?.number}}  {{s.createdByName}}

                    </h6>
                    <span class="p-ml-4">
                        <span>{{s.objectData.createdDate | localDate}}</span>
                    </span>
                    <p style="word-break: break-all;" class="p-mb-0">
                        {{ (s.objectData?.comment !== undefined || s.objectData?.comment !== "") && s.objectData?.comment.length
                        < 343 ? s.objectData?.comment : s.objectData?.comment.substring(0,343) + "..." }} </p>
                </ng-container>
                <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'Location' ">
                    <h6 class="p-mb-1" style="display: inline-block;">
                        {{s.type}} {{ s | activityBy }} {{s.createdByName}}
                    </h6>
                    <span class="p-ml-4">
                        <span>{{s.objectData.createdDate | localDate}}</span>
                    </span>
                    <p style="word-break: break-all;" class="p-mb-0">
                        {{ (s.objectData?.comment !== undefined || s.objectData?.comment !== "") && s.objectData?.comment.length
                        < 343 ? s.objectData?.comment : s.objectData?.comment.substring(0,343) + "..." }} </p>
                </ng-container>
                <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type == '' ">
                    <h6 class="p-mb-1" style="display: inline-block;">
                        {{ s | activityBy }} {{s.createdByName}}
                    </h6>
                    <span class="p-ml-4">
                        <span>{{s.objectData.createdDate | localDate}}</span>
                    </span>
                    <p style="word-break: break-all;" class="p-mb-0">
                        {{ (s.objectData?.comment !== undefined || s.objectData?.comment !== "") && s.objectData?.comment.length
                        < 343 ? s.objectData?.comment : s.objectData?.comment.substring(0,343) + "..." }} </p>
                </ng-container>
            </div>
        </div>
    </p-card>
    <!--
        <p-card class="activity-card" *ngIf="app.allActivityLogsList != null && app.allActivityLogsList.length < 1">
        </p-card>
    -->
    <div *ngIf="!app.allActivityLogsList || !app.allActivityLogsList.length">
        <h6 class="p-mt-4" style="display: inline-block;">
            No Result Found.
        </h6>
    </div>

    <div class="p-text-center loadmoreWrapper" *ngIf="app.allActivityLogsList?.length">
        <button pButton type="button" (click)="loadMore()" class="p-button-raised p-button-rounded" label="Load More">
        </button>
    </div>
</p-dialog>

<app-shared-detail-popup *ngIf="displayDetailPopup" [moduleType]="moduleType" [currentDisplay]="displayDetailPopup" [header]="popupHeader" [associationTypeId]="associationTypeId" [dataId]="dataId" (dialogClosed)="closeDialog()">
</app-shared-detail-popup>

<app-lion-log-details-popup [displayLogDetailPopup]="displayLogDetailPopup" [logData]="logData" [isViewMode]="isViewMode" (cancelLogPopupDetails)="cancelLogPopupDetails()">
</app-lion-log-details-popup>

<app-lion-note-details-popup [displayNoteDetailPopup]="displayNoteDetailPopup" [noteData]="noteData" [isViewMode]="isViewMode" (cancelNotePopupDetails)="cancelNotePopupDetails()">
</app-lion-note-details-popup>

<app-lion-active-inactive-modal *ngIf="displayActiveInactiveModal" [commentHeaderName]="commentHeaderName" [displayActiveInactiveModal]="displayActiveInactiveModal" [activeInactiveFormType]="activeInactiveFormType" [activeInactiveData]="activeInactiveData"
    [moduleName]="moduleName" (cancelActiveInactiveModal)="cancelActiveInactiveModal()">
</app-lion-active-inactive-modal>

<app-lion-email-details-popup [objectTypeId]="objectTypeId" [displayEmailDetailPopup]="displayEmailDetailPopup" [emailAudit]="emailAudit" [emailAuditId]="emailAuditId" [isViewMode]="isViewMode" (cancelEmailPopupDetails)="cancelEmailPopupDetails()">
</app-lion-email-details-popup>

<app-lion-email-reply-popup [displayEmailReplyPopup]="displayEmailReplyPopup" [emailReplyData]="emailReplyData" (cancelEmailReplyPopup)="cancelEmailReplyPopup()">
</app-lion-email-reply-popup>
